<app-header extraClass="text-gray nav-down" standardProduct=true displayNavigation=true></app-header>

<section class="order-confirmation-wrp mt-120 mb-5">
  <div class="container">
    <div class="confirmation-wrp-all w-850">

      <div class="progress-bar-wrp mb-3 position-relative">
        <ul class="progressbar uk-flex">
          <li class="active">
            <div class="icon-checked"></div>
            <span> <i>Payment</i>  Received</span>  
          </li>
          <li>
            <div class="icon-checked"></div>
            <span> <i>Waiting</i>  Confirmation</span> 
          </li>
          <li>
            <div class="icon-checked"></div>
            <span> <i>Booking</i>  Success</span>
          </li>
        </ul>
      </div><!-- progress-bar-wrp end -->


      <div class="heading">
        <h4>Your booking request has been confirmed!</h4>
        <p>We will get back to you in 24 hours with the confirmation of this experience from our partners</p>
      </div>

      <div class="experience-details-wrp mt-3 uk-flex">
        <div class="w-50 image-info">
          <h4>Your Experience Details</h4>
          <div class="image position-relative">
            <img src="assets/images/banner-1.jpg" alt="" class="fitimg">
            <div class="icon">
              <img src="assets/images/icons/tick-2.png" alt="">
            </div>
          </div>
        </div>
        <div class="w-50 details-info">
          <div class="details">

            <div class="sharing-card-wrp">
              <h5><img src="assets/images/icons/location-black.png" alt=""> Mumbai</h5>
              <h4>Campervan Adventures</h4>
              <div class="uk-flex uk-flex-middle">
                <span>Once in a Lifetime</span>
                <div class="position-relative">
                  <i class="fa fa-share-alt cursor-pointer opensharelink sharing-link"
                      (click)="openShareLink()"></i>
                  <div class="sharelink uk-flex uk-flex-middle">
                    <share-buttons [theme]="'default'"
                        [include]="['facebook','twitter','telegram','whatsapp','sms','email']"
                        [autoSetMeta]="false">
                    </share-buttons>
                  </div>
                </div>
                <a  class="listshare"><i  href="#modal-center" uk-toggle="" class="fa fa-bookmark-o"  aria-expanded="false"></i></a>
              </div>
            </div><!-- sharing-card-wrp end -->

            <div class="date-and-time-wrp">
              <h4>Date and Time</h4>
              <p>Sat, 07 September 2021</p>
              <span>7 am - 9:30 am</span>
            </div><!-- date-and-time-wrp end -->

          </div>
        </div>
      </div><!-- experience-details-wrp end -->

      <div class="order-summary-wrp uk-flex">
        <div class="w-50 details-wrp">

          <div class="details">
            <h5>Order Summary</h5>
            <div class="show-on-mobile">
              <span>Order ID : 123458898</span>
            </div>

            <div class="uk-flex uk-flex-wrap order-price mt-1 mb-2">
              <p>1x Campervan Adventures for 6 people</p>
              <h4><i class="fa fa-rupee"></i> 25,499 </h4>
            </div>

            <div class="uk-flex others-details uk-flex-middle">
              <h4>Paid On</h4>
              <p>7th Sep, 2021</p>
            </div>

            <div class="uk-flex others-details uk-flex-middle">
              <h4>Payment Method</h4>
              <p>Debit Card</p>
            </div>

          </div>

        </div>

        <div class="w-50">
          <div class="total">
            <span>Order ID : 123458898</span>
            <div class="cost-total">
              <p>Total (INR)</p>
              <h4><i class="fa fa-rupee"></i> 25,499 </h4>
            </div>
          </div>
        </div>

      </div>



    </div><!-- confirmation-wrp-all end -->


    <div class="need-help uk-flex uk-flex-middle uk-flex-between mt-4 mb-4">
      <div class="info">
          <h4>Need our Help?</h4>
          <p>Reach out to us if you have any questions!</p>
      </div>
      <div class="number">
          <a href="tel:18002667666"> <img src="assets/images/icons/call-4.png" alt=""> 1800 105 8859</a>
      </div>
    </div>

    <div class="btn-box">
      <a href="">Go BACk TO HOME PAGE</a>
    </div>
    
  </div>
</section>


<!-- footer -->
<app-footer></app-footer>
